export const CREDIT_SCORE_FORMAT = '^(-1|0|1|[3-8][0-9]{2}|900)$';

export const EMAIL_FORMAT = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$';